// extracted by mini-css-extract-plugin
module.exports = {"block":"style__block__sTBsX"};